import * as types from './types';

export const getDataGA = data => {
	return {
		type: types.GET_DATA,
		payload: { data }
	};
};

export const resetDataGA = () => ({
	type: types.CLEAR_DATA
});
